import axios from 'axios'
import envConfigs from '../configs/envConfigs'
import { portalAuthHttpClient } from '../utils/HttpRequestUtils'

export const getUserProfile = async ({ userCode }) => {
	const url = `${envConfigs.baseUrl}${envConfigs.getUserDetailsUrl}?userCode=${userCode}`
	const response = await portalAuthHttpClient.get(url)
	return response.data
}
export const getUserIdByAgentCode = async (reqObj) => {
	const url = `${envConfigs.baseUrl}${envConfigs.getUserIdByAgentCode}`
	const response = await portalAuthHttpClient.post(url,reqObj)
	return response.data
}

export const createUser = async (data) => {
	const url = `${envConfigs.baseUrl}${envConfigs.createUserUrl}`
	const response = await portalAuthHttpClient.post(url, data)
	return response.data
}

export const updateUser = async (data) => {
	const url = `${envConfigs.baseUrl}${envConfigs.updateUserUrl}`
	const response = await portalAuthHttpClient.post(url, data)
	return response.data
}

export const getRegionByAirportCode = async (code) => {
	const url = `${envConfigs.baseUrl}${envConfigs.getRegionByAirportCode}/${code}`
	//const url = `http://13.126.80.20/api/api/masterdata/getregionbyairportcode/${code}`
	const response = await portalAuthHttpClient.get(url)
	return response.data
}

export const saveNotificationSubscription = async (data) => {
    const url = `${envConfigs.csnUrl}${envConfigs.saveNotificationSubscription}`
  	// const url = `http://localhost:8323/notification/save-notification-config`
	const response = await portalAuthHttpClient.post(url, data)
	return response.data
}

export const getNotificationSubscription = async (agentCode, userId) => {
	const url = `${envConfigs.csnUrl}${envConfigs.getNotificationSubscription}/${agentCode}/${userId}`
	// const url = `http://localhost:8323/notification/get-notification-config/${agentCode}/${userId}`
	const response = await portalAuthHttpClient.get(url)
	return response.data
}

export const saveAWBNotificationSubscription = async (data) => {
	const url = `${envConfigs.csnUrl}${envConfigs.saveAWBNotificationSubscription}`
	// const url = `http://localhost:8323/notification/save-awb-subscription`
	const response = await portalAuthHttpClient.post(url, data)
	return response.data
}

export const getNotificationMilestone = async (agentCode, awb) => {
	const url = `${envConfigs.csnUrl}${envConfigs.getAWBNotificationSubscription}/${agentCode}/${awb}`
	// const url = `http://localhost:8323/notification/get-awb-subscription/${agentCode}/${awb}`
	const response = await portalAuthHttpClient.get(url)
	return response.data
}
